/** The name of a day of the week (1 Monday to 7 Sunday) in a language, long ("Monday") or short ("Mon"). */
export function weekdayName(day: number, locale: string, width: "long" | "short" = "long"): string {
  return new Intl.DateTimeFormat(locale, { weekday: width, timeZone: "UTC" }).format(new Date(Date.UTC(2026, 0, 4 + day)));
}
